import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { FormationsService } from '../../../../services/formations.service';
import { TagModule } from 'primeng/tag';
import { DataViewModule } from 'primeng/dataview';
import { SelectButtonModule } from 'primeng/selectbutton';
import { FormsModule } from '@angular/forms';
import { loadStripe } from '@stripe/stripe-js';
import { environment } from '../../../../../environments/environments';
import { MessageService } from 'primeng/api';


@Component({
  selector: 'app-formations',
  standalone: true,
  imports: [CommonModule, ButtonModule, TagModule, DataViewModule, SelectButtonModule, FormsModule],
  templateUrl: './formations.component.html',
  styleUrl: './formations.component.scss'
})
export class FormationsComponent implements OnInit {
  private formationsService = inject(FormationsService);
  private messageService = inject(MessageService);
  private apiUrl = environment.apiUrl;
  loadStripe = environment.loadStripe;
  layout: "list" | "grid" = 'grid';
  options = ['list', 'grid'];

  formations = signal<any[]>([]);
  loading = signal(true);



  ngOnInit(): void {

    const user_id = JSON.parse(localStorage.getItem('user') || '{}').user_id

    this.formationsService.getFormationsBasedOnUser(user_id).subscribe({
      next: (data) => {
        // sécurité: on n'affiche que les formations actives si le champ existe
        const list = data
        this.formations.set(list);
        this.loading.set(false);
        console.log("this is the formation", this.formations())
      },
      error: () => {
        this.loading.set(false);
      }
    });
  }
  stripePromise = loadStripe(this.loadStripe);



  downloadFormation(item: any) {
    const user_id = JSON.parse(localStorage.getItem('user') || '{}').user_id
    const url = this.apiUrl + `api/formations/${item.id}/download/${user_id}`;
    this.formationsService.downloadFormation(item.id, user_id).subscribe({
      next: (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');

        a.href = url;
        a.download = `${item.title}.pdf`; 
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: (err) => {
        console.error('Download failed', err);
      }
    });
  }
  async purchase_formation(item: any) {
    const formation_id = item.id;
    const stripe = await this.stripePromise;
    const response = await fetch(environment.apiUrl + 'api/stripe/create-checkout-session/formation', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token') || ''}`
      },
      body: JSON.stringify({
        user_id: JSON.parse(localStorage.getItem('user') || '{}').user_id,
        formation_id: formation_id
      }),
    });

    const session = await response.json();
    if (!response.ok) {
      console.error('Error creating checkout session:', session);
      this.messageService.add({ severity: 'error', summary: 'Payment Error', detail: 'There was an error processing your payment. Please try again.' });
      return;
    }
    const result = await stripe?.redirectToCheckout({
      sessionId: session.sessionId,
    });



  }

  openPdf(f: any) {
    if (!f?.pdf_path) return;
    // si pdf_path est déjà une URL complète, ça marche direct
    // sinon, ton backend doit servir un chemin public
    window.open(f.pdf_path, '_blank');
  }
}
